module.exports = __webpack_public_path__ + "img/gift4.12287322.png";